// Helper functions for formatting analytics data

export function formatDuration(ms: number | null): string {
  if (ms === null) return "Insufficient data";
  if (ms === 0) return "0m";
  const hours = Math.floor(ms / (1000 * 60 * 60));
  const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
  if (hours === 0) return `${minutes}m`;
  return `${hours}h ${minutes}m`;
}

export function formatTimeDeviation(deviation: number): string {
  return deviation.toFixed(1);
}

export function formatPercentage(percentage: number): string {
  return percentage.toFixed(1);
}
